export const SSO_URL = "https://sso.simulanis.io";
// export const API_URL = "http://localhost:3333";
export const API_URL = "https://api.creator.simulanis.io";

// export const applicationId = "a7bae9ea-dd51-4487-b5bf-5ff6a6a96d38";  // view it 360
export const applicationId = "16269833-3c0f-42a4-8e89-dc3347fb908c";  // do it 360